import { supabase } from "@/integrations/supabase/client";


/**
 * Auto-enroll a user in a course if they don't already have a
 * user_course_progress row. Returns the existing or newly created row.
 */
export async function enrollInCourse(userId: string, courseId: string) {
  // Check for existing enrollment
  const { data: existing } = await supabase
    .from("user_course_progress")
    .select("*")
    .eq("user_id", userId)
    .eq("course_id", courseId)
    .maybeSingle();

  if (existing) return existing;

  // Create enrollment
  const { data, error } = await supabase
    .from("user_course_progress")
    .insert({
      user_id: userId,
      course_id: courseId,
      completed_nodes: 0,
      total_xp: 0,
    })
    .select()
    .single();

  if (error) {
    console.error("Failed to enroll in course:", error);
    throw error;
  }

  
  return data;
}
